import { Link } from 'react-router-dom';

import { C, FONT, Icon, LifecycleJourneyIcon, PATHS } from './Overview/ui';

import PermissionComponent from '@/routes/PermissionComponent';
import ROUTES from '@/routes/routes';
import styled from '@/styles';

const Button = styled(Link, {
  height: 36,
  padding: '0 12px',
  boxSizing: 'border-box',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  borderRadius: 12,
  background: C.white,
  boxShadow: `inset 0 0 0 1px ${C.stroke}`,
  color: C.black,
  fontFamily: FONT,
  fontSize: 14,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  '&:hover': { background: C.optionHover, color: C.black },
});

// The GravyWorkers page's way into the Lifecycle journeys page (design
// v2check). Shown only to roles that can open /lifecycle.
const LifecycleJourneysButton = () => (
  <PermissionComponent id="nav-lifecycle-link">
    <Button
      data-testid="lifecycleJourneysBtn"
      to={`/${ROUTES.lifecycle}`}
      // Read by the page's lifecycle_viewed event (entry: gravyworkers).
      state={{ lifecycleEntry: 'gravyworkers' }}
    >
      <LifecycleJourneyIcon />
      <span>Lifecycle journeys</span>
      <Icon d={PATHS.arrowRight} size={20} />
    </Button>
  </PermissionComponent>
);

export default LifecycleJourneysButton;
